import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import AppPay from '../../template/Pay/AppPay';
import { COURSE_URL } from "../../constants";
import { parseQuery } from '../../utils/tools';
import AXIOS from '../../api/axios';
import clientApi from '../../api/client';

const queryObj = parseQuery(window.location.search.slice(1));

class AppPayPage extends Component {
    constructor(props){
        super(props);
        this.state = {
            lessonCnt:'0',
            lessonDate:'',
            goodsInfo:[],
            stuId:queryObj.stuid
        };
        this._pushPage.bind(this);
    }
    _pushPage = (path, id)=>{
        const _this = this;
        const { history } = this.props;
        history.push({
          pathname: `${COURSE_URL}/${path}`,
          state: {id:id,goodsInfo:_this.state.goodsInfo},
          search:window.location.search
        });
    }
    componentDidMount(){
        const _this = this;
        AXIOS.getStuCourse({data:{stuId:queryObj.stuid}},function(res,err){
            if(err){
                clientApi.httpError({errorCode:err.errorCode})
            }else{
                _this.setState({ 
                    lessonCnt : res[0].remainLessonCnt, 
                    lessonDate  : res[0].expireDate.replace(/-/g,'.')
                })
            }
        })
        AXIOS.getGoodsInfo({data:{userId:queryObj.stuid}},function(res,err){
            if(err) console.log(err)
            else{
                _this.setState({ goodsInfo:res })
            }
        })
    }
    render(){
        const propsObj = {
            pushPage:this._pushPage
        };
        return(
            <DocumentTitle title={'课时信息'}>
                <div className="page_wrap">
                <AppPay {...propsObj} {...this.state}/>
                </div>
            </DocumentTitle>
        )
    }
}

export default AppPayPage;



// WEBPACK FOOTER //
// ./src/components/payPage/AppPayPage.jsx